import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Hata durumunda state güncellenir.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Hataları loglamak için kullanılabilir.
    console.error("Error caught in ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      // Kullanıcıya gösterilecek yedek UI.
      return <h1>Bir hata oluştu. Lütfen tekrar deneyin.</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
